module.exports = __webpack_public_path__ + "static/Tastea6-4a404cc94a8d58b561a3bf9f3a38bce8.jpg";